import React, { useState } from "react";
import { Input } from "@swordsweeper/ssi-ui-component-library";
import styles from "./PasswordInput.module.scss";

interface PasswordInputProps {
  label: string;
  value?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: boolean;
  width?: number | string;
  required?: boolean;
  autoComplete?: boolean;
  "data-testid"?: string;
}

export default function PasswordInput({
  label,
  value,
  onChange,
  onBlur,
  error,
  width = "100%",
  required,
  autoComplete,
  "data-testid": dataTestId,
}: PasswordInputProps): React.JSX.Element {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={styles.wrapper} style={{ width }}>
      <Input
        defaultValue=""
        label={label}
        type={isVisible ? "text" : "password"}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        width={width}
        required={required}
        autoComplete={autoComplete}
        data-testid={dataTestId}
      />
      <i
        className={`fa-regular ${isVisible ? "fa-eye-slash" : "fa-eye"} ${styles.toggleIcon}`}
        onClick={() => setIsVisible((prev) => !prev)}
        role="button"
        tabIndex={0}
        aria-label={isVisible ? "Hide password" : "Show password"}
        aria-pressed={isVisible}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsVisible((prev) => !prev);
          }
        }}
        data-testid={dataTestId ? `${dataTestId}-toggle` : undefined}
      />
    </div>
  );
}